module.exports = __webpack_public_path__ + "assets/img/line2.d8fdc553.png";